import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from '../../models/user-settings';

@Injectable({
  providedIn: 'root',
})
export class UserSettingsService {
  private apiUrl = environment.apiBaseUrl;
  private http: HttpClient = inject(HttpClient);

  getUserSettingsByType(type: string) {
    return this.http.get(`${this.apiUrl}/api/user/settings/${type}`);
  }

  createUserSettingsByType(type: string, settings: UserSettings) {
    return this.http.post(`${this.apiUrl}/api/user/settings/${type}`, settings);
  }

  updateUserSettingsByType(type: string, settings: UserSettings) {
    return this.http.patch(
      `${this.apiUrl}/api/user/settings/${type}`,
      settings,
    );
  }

  deleteUserSettingsByType(type: string) {
    return this.http.delete(`${this.apiUrl}/api/user/settings/${type}`);
  }
}
